import { useEffect, useState } from 'react';
import { useOrderContext } from '../context/OrderContext';
import { useUserContext } from '../context/UserContext';
import { searchActionTypes } from '../app/enums';
import SearchHistoryGrid from '../components/Search/SearchHistoryGrid';
import {  useSearchContext } from '../context/SearchContext';
import { Container, Grid, Typography } from '@material-ui/core';
import { OrderDetailsDialog } from '../components/Dialogs/OrderDetailsDialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import { AddToCartDialog } from '../components/Dialogs/AddToCartDialog';
import { Orders } from '../api/api';
import { Order } from '../models/order.interface';
import { defaultSearchResponse, SearchType } from '../models/search.interface';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles ({
    pageTitle: {
      color: theme.palette.primary.dark,
      fontWeight: 'bold',
    },
    gridSpacer: {
      minHeight: '12px',
    },
    container: {
      padding: 20,
    },
  }),
);

export const SearchHistory = () => {
  const classes = useStyles(); 
  const { state, dispatch } = useSearchContext();
  const order = useOrderContext();
  const user = useUserContext();
  const [ open, setOpen ] = useState<boolean>(false);
  const [ loading, setLoading ] = useState<boolean>(true);

  const showOrderDetailDialog = () => {
    setOpen(true);
  };

  const handleOrderDetailClose = () => {
    setOpen(false);
    order.dispatch({type: 'field', fieldName: 'orderId', payload:''})
  };

  const handleAddToCartClose = () => {
    dispatch({type: searchActionTypes.HIDE_ADD_TO_CART})
  };

  const loadSearchOrderMap = () => {
    let orderMap:Map<string, Order> = new Map<string, Order>();
    let optionalItemsMap:Map<string, OptionalItem> = new Map<string, OptionalItem>();

    Orders.getSelfOrders(user.state.self.locations[0].id)
      .then((orderList) => {
        orderList.forEach((order) => {
          order.items.forEach((item) => {
            orderMap.set(item.searchId, order)

          if(item.lotNumber || item.sellerName){
              let optItem: OptionalItem = {
                lotNumber: item.lotNumber,
                sellerName: item.sellerName
              } 

              optionalItemsMap.set(item.searchId, optItem)
            }
          })  
        })
        dispatch({ type: searchActionTypes.LOAD_ORDER_MAP, searchOrderMap: orderMap})
        dispatch({ type: searchActionTypes.LOAD_OPTIONAL_ITEMS_MAP, searchOptionalItemMap: optionalItemsMap})
        setLoading(false)
      })
      .catch((error) => {
        console.log('Order details error', error)
      }) 
  }

  useEffect(() => {
    loadSearchOrderMap();
  },[loading])
  
  return (
    <Container
      component="main"
      className={classes.container}
    >
      <Grid container spacing = {0}>
        <Grid item sm>
          <Typography className={classes.pageTitle} variant="h5">
            Search History
          </Typography>
          <Grid container className={classes.gridSpacer} />
          { loading 
            ? <Grid container 
                justifyContent="center"
                alignItems="center"
              >
                <CircularProgress color="primary" />
              </Grid>
            : <SearchHistoryGrid onOpen={showOrderDetailDialog} />
              
          }      
        </Grid>  
      </Grid>
      <OrderDetailsDialog      
        open={open} 
        onClose={handleOrderDetailClose} 
      />
      <AddToCartDialog 
        open={state.addToCartDialogOpen}
        onClose={handleAddToCartClose}
        item={state.addToCartItem || defaultSearchResponse}
        vin={state.addToCartVin || ''}
      />
    </Container>
  )
};

export default SearchHistory;
